import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  // Typography,
  DialogTitle
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import './ConfirmationDialogStyles.scss';
import ButtonLoader from '../ButtonLoader/ButtonLoader';
// interface for Confirmation Dialog props
interface ConfirmationDialogProps {
  open: boolean;
  title: string | React.ReactElement;
  description: string | React.ReactElement;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onClose(response: 'confirm' | 'cancel'): void;
  className?: any | Record<string, unknown>;
  loader?: boolean;
  dialogProps?: Omit<DialogProps, 'open'>;
  validationErrors?: boolean;
  // validConfirmationDialogData?: boolean;
}

const ConfirmationDialog = (
  props: ConfirmationDialogProps
): React.ReactElement => {
  const {t} = useTranslation();

  // props de-structure
  const {
    open,
    onClose,
    title,
    description,
    cancelButtonText,
    confirmButtonText,
    className,
    loader = false,
    dialogProps = {},
    validationErrors
    // validConfirmationDialogData,
  } = props;

  const [buttonsDisable, setButtonsDisable] = React.useState<boolean>(false);

  const handleClose = React.useCallback(
    (response: 'confirm' | 'cancel') => {
      if (typeof onClose === 'function') {
        onClose(response);
      }
    },
    [onClose]
  );

  // React.useEffect(() => {
  //   console.log('validDateRange', validDateRange);
  // }, [validDateRange]);
  return (
    <Dialog
      maxWidth={'md'}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={handleClose}
      aria-labelledby="confirm-dialog"
      aria-describedby="confirm-dialog"
      {...dialogProps}>
      <DialogTitle disableTypography>{title}</DialogTitle>
      {description && <DialogContent dividers>{description}</DialogContent>}
      <DialogActions>
        <Button
          data-test-id="pcl-appointments-popupCancel"
          onClick={() => {
            setButtonsDisable(false);
            handleClose('cancel');
          }}>
          {cancelButtonText || t('COMMON.CANCEL')}
        </Button>
        <Button
          style={{...className}}
          variant={'contained'}
          disabled={buttonsDisable || loader}
          onClick={() => {
            if (!validationErrors) {
              setButtonsDisable(true);
              setTimeout(() => {
                setButtonsDisable(false);
              }, 3000);
            }
            handleClose('confirm');
          }}
          color="primary">
          {buttonsDisable || loader ? (
            <ButtonLoader />
          ) : (
            confirmButtonText || t('COMMON.CONFIRM')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
